module.exports = __webpack_public_path__ + "static/media/card_icon.655627bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/card_icon.png
// module id = 1595
// module chunks = 0